import { Box, Grid, SvgIcon, Typography } from '@mui/material';
import React from 'react';
import { HormoneSnapshot, ResultType } from '../../../types';
import { StressData } from '../../../views/StressInsights';
import { AccordionCard } from '../../Library/AccordionCard';
import { ReactComponent as RecommendationIcon } from '../../../images/Take-final.svg';
import { colors } from '../../../utils/theme';
import { StressRecommendationDetails } from './StressRecommendationDetails';

export const StressRecommendations = ({
  stressDataMap,
  snapShot,
}: {
  stressDataMap: Record<ResultType, StressData>;
  snapShot: HormoneSnapshot;
}): JSX.Element => {
  return (
    <Box display="flex" flexDirection="column">
      <Typography variant="light" fontSize={14} sx={{ mt: 3 }}>
        Balancing your stress response requires a personalized, comprehensive
        approach. From cell to system, we've got you covered!
      </Typography>
      <Typography variant="light" fontSize={14} sx={{ mt: 3, mb: 3 }}>
        See your personalized
        <Typography variant="medium" sx={{ mx: 0.5 }}>
          IMPROVEMENT PLAN
        </Typography>
        to conquer stress:
      </Typography>
      {stressDataMap[snapShot?.result as ResultType]?.recommendations?.map(
        (recommendationType, index: number) => (
          <Box key={`${recommendationType.name}-${index}`} sx={{ mb: 1 }}>
            <AccordionCard
              panelId="stress-recommendations"
              summary={
                <Grid
                  container
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Grid
                    container
                    flexDirection="row"
                    alignItems="center"
                    item
                    xs={7}
                    sm={5}
                  >
                    <SvgIcon
                      component={RecommendationIcon}
                      inheritViewBox
                      sx={{
                        width: 16,
                        height: 16,
                        mr: 0.5,
                        fill: colors.greys.BASE_WHITE,
                      }}
                    />
                    <Typography variant="light" fontSize={14}>
                      RECOMMENDATIONS
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    justifyContent="flex-end"
                    item
                    xs={4}
                    sm={5}
                    sx={{ mr: 1 }}
                  >
                    <Typography fontSize={16}>
                      {recommendationType.label}
                    </Typography>
                  </Grid>
                </Grid>
              }
              details={
                <StressRecommendationDetails
                  recommendationType={recommendationType}
                />
              }
            />
          </Box>
        )
      )}
    </Box>
  );
};
